import { FC } from 'react';

import Loader from 'components/Loader';
import ProcessCard, { ProcessCardConfig } from 'components/processes/ProcessCard';
import { useProcessStatusPolling } from 'components/processes/useProcessStatusPolling';

const SAGE_HR_CARD_CONFIG: ProcessCardConfig = {
    type: 'SAGE_HR_SYNC',
    titleId: 'sage-hr.title',
    descriptionId: 'sage-hr.description',
    runButtonId: 'sage-hr.sync',
    inProgressLabelId: 'sage-hr.in-progress',
    progressMessageId: 'sage-hr.in-progress',
    successChipLabelId: 'sage-hr.success',
    successAlertId: 'sage-hr.success',
    errorGeneralId: 'sage-hr.error-general',
    errorAlreadyRunningId: 'sage-hr.error-already-running',
    buttonVariant: 'outlined',
    buttonColor: 'primary',
};

const SageHrSync: FC = () => {
    const { statuses, isLoading: isLoadingStatuses } = useProcessStatusPolling();

    if (isLoadingStatuses) {
        return <Loader />;
    }

    return <ProcessCard config={SAGE_HR_CARD_CONFIG} isRunning={statuses?.SAGE_HR_SYNC ?? false} />;
};

export default SageHrSync;
